import { ZigzinDelayShipmentBanner } from '../components/zigzin/ZigzinDelayShipmentBanner';
import { useZigzinDelayShipmentBannerService } from '../services/useZigzinDelayShipmentBannerService';

export const ShippingZigzinDelayShipmentBannerContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { url, is_hide, handleClick } = useZigzinDelayShipmentBannerService();

  if (is_hide) {
    return null;
  }
  return <ZigzinDelayShipmentBanner url={url} handleClick={handleClick} />;
};
